module.exports = __webpack_public_path__ + "img/bc-active.0542f6e5.jpg";